import styled from "@emotion/styled";
import { Box, ButtonBase } from "@mui/material";

export const StyledThumbnailPreview = styled(Box)({
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    gap: 4,
    width: 160,
});

export const StyledThumbnailPreviewImage = styled("img")({
    aspectRatio: "16/9",
    borderRadius: 8,
    display: "block",
    objectFit: "cover",
    width: "100%",
});

export const StyledThumbnailPreviewPlaceholder = styled(ButtonBase)(({ theme }) => ({
    "&.Mui-disabled": { opacity: 0.5 },
    aspectRatio: "16/9",
    border: `1px solid ${theme.palette?.primary.main}66`,
    borderRadius: 8,
    width: "100%",
}));

export const StyledThumbnailPreviewLoader = styled(Box)(({ theme }) => ({
    alignItems: "center",
    background: theme.palette?.grey[901],
    borderRadius: 8,
    display: "flex",
    inset: 0,
    justifyContent: "center",
    position: "absolute",
}));
